import {
    type DefineFilterGroupInput,
    defineFilterGroup,
} from "app/pages/sales-intelligence/modules/advanced-search-filtering/services/filters-registry/defineFilterGroup";

import type { LeadsCapability } from "../types/leadsCapability";
import type { LeadsDataSource, LeadsFilterBuildContext } from "../types/leadsFilterBuildContext";
import type { LeadsFilterGroupDefinition } from "../types/leadsFilterDefinition";
import type { ILeadsSearchFiltersDto, LeadsSearchAllFiltersTypes } from "../types/leadsSearchFilters.dto";

export type DefineLeadsFilterGroupInput = DefineFilterGroupInput<
    LeadsSearchAllFiltersTypes,
    keyof ILeadsSearchFiltersDto,
    LeadsFilterBuildContext,
    LeadsDataSource,
    LeadsCapability
>;

/** Leads binding of `defineFilterGroup`. */
export const defineLeadsFilterGroup = (input: DefineLeadsFilterGroupInput): LeadsFilterGroupDefinition =>
    defineFilterGroup(input);
